


















































































interface Area {
    code: string;
    regionName: string;
    id?: string | number;
}
import { Component, Vue } from "vue-property-decorator"
@Component
export default class EditArea extends Vue {
    areas: Area[] = [];
    newArea: Area = {
        regionName: "",
        code: ""
    };
    trIndex: number = -1;
    tmp: string = "";

    mounted() {
        this.getAreas()
    }

    getAreas() {
        // 地区 下拉列表
        Vue.axios.get(`regions/find`).then(response => {
            this.areas = response.data;
        });
    }
    selectAll(e: TextEvent, isNewCode: boolean) {
        this.tmp = (<HTMLInputElement>e.target).value;
        (<HTMLInputElement>e.target).select();
        if (isNewCode) {
            let lastCode = this.areas[this.areas.length - 1].code;
            let tmpCode: number = (Number(lastCode) + 1), newCode = "";
            if (tmpCode < 10)
                newCode = "000" + tmpCode;
            else if (tmpCode < 100 && tmpCode >= 10)
                newCode = "00" + tmpCode;
            else if (tmpCode < 1000 && tmpCode >= 100)
                newCode = "0" + tmpCode;
            else
                newCode = tmpCode.toString();
            // console.log(newCode)
            this.newArea.code = newCode;
        }
    }
    updateArea(e: TextEvent, data: Area) {
        this.judgeForm(e, data, () => {
            // // 修改
            Vue.axios.post("regions/edit", {
                "id": data.id,
                "regionName": data.regionName,
                "code": data.code
            }).then((response: any) => {
                this.getAreas();
                this.$message({
                    showClose: true,
                    message: "修改成功!",
                    type: "success"
                })
            });
        })
    }
    createArea(e: TextEvent, data: Area) {
        this.judgeForm(e, data, () => {
            Vue.axios.post("regions/add", this.newArea).then(response => {
                this.getAreas();
                this.newArea.code = "";
                this.newArea.regionName = "";
                this.$message({
                    showClose: true,
                    message: "新增成功!",
                    type: "success"
                })
            });
        })
    }
    judgeForm(e: TextEvent, data: Area, cb: Function) {
        if (data.regionName == "" && data.code != "") {
            this.$message({
                showClose: true,
                message: "请输入区域名!",
                type: "warning"
            })
            return
        }
        if (data.code == "" && data.regionName != "") {
            this.$message({
                showClose: true,
                message: "请输入区域编号!",
                type: "warning"
            })
            return
        }
        if ((<HTMLInputElement>e.target).value != this.tmp && data.regionName != "" && data.code != "") {
            cb()
        }
    }
    deleteArea(data: Area) {
        this.$confirm("亲，确定要删除这个区域吗？", "温馨提示", {
            confirmButtonText: "确定",
            callback: action => {
                if (action == "confirm") {
                    Vue.axios.post("regions/delete", {
                        "id": data.id,
                        "regionName": data.regionName,
                        "code": data.code,
                    }).then(response => {
                        this.getAreas();
                        this.$message({
                            showClose: true,
                            message: "删除成功!",
                            type: "success"
                        })
                    });
                }
            }
        });
    }
}
